module.exports = __webpack_public_path__ + "static/media/20ECE7.078df1dc.jpg";